import { NextResponse } from "next/server";
import { readFile } from "node:fs/promises";
import { join } from "node:path";

export const revalidate = 60; // ISR for this API (optional)

export async function GET() {
  const filePath = join(process.cwd(), "src/data/home.json");
  const raw = await readFile(filePath, "utf-8");
  return NextResponse.json(JSON.parse(raw));
}
